import request from '@/plugin/axios'

export function getSysResourseList (params) {
  return request({
    url: '/v1/electricity/resourse/queryResourse',
    method: 'get',
    params: params
  })
}

// export function getSysResourseList (params) {
//   return request({
//     url: '/v1/electricity/resourse/queryResourse',
//     method: 'get',
//     params: params
//   })
// }

export function getResourseByRoleId (params) {
  return request({
    url: '/v1/electricity/resourse/queryResourseByRoleId',
    method: 'get',
    params: params
  })
}

export function getResourseByRoleIdTree (params) {
  return request({
    url: '/v1/electricity/resourse/queryResourseByRoleIdTree',
    method: 'get',
    params: params
  })
}

export function saveSysResourse (data) {
  return request({
    url: '/v1/electricity/resourse/saveResourse',
    method: 'post',
    data
  })
}

export function updateSysResourse (data) {
  return request({
    url: '/v1/electricity/resourse/updateResourse',
    method: 'put',
    data
  })
}

export function deleteSysResourseById (data) {
  return request({
    url: '/v1/electricity/resourse/deleteResourse',
    method: 'DELETE',
    headers: {
      'Content-Type': 'x-www-form-urlencoded'
    },
    params: data
  })
}
